var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},_vm._l((_vm.alerts),function(alert,key){return _c('div',{key:key,staticClass:"alert",class:alert.type,domProps:{"textContent":_vm._s(alert.content)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }